import { createContext } from 'react';
import { IntegrationT } from 'routes/IntegrationsList/types';

export const IntegrationContext: React.Context<IntegrationT[]> = createContext<
    IntegrationT[]
>([]);
